import React, { Component } from 'react'
import { Button, Checkbox } from 'hljd'
import { observer } from 'mobx-react'
import { Link } from 'react-router'

import {
  VR_CREATE_PATH,
  VR_SELL_PATH,
  VR_VERIFY_SUC
} from '@components/Hotel/constant'

import { corpImage } from '@components/Hotel/util'
import VideoUpload from '@common/Hotel/VideoUpload'
import AlbumModal from './AlbumModal'
import ImgUpload from './ImgUpload'
import style from './style.module.less'
import Store from './store'
import PlusOutlined from '@ant-design/icons/lib/icons/PlusOutlined'
import ImgCard from '@components/Hotel/CoverSetting/CoverTemplate/ImgCard'

@observer
export default class extends Component {
  constructor() {
    super()
    this.store = new Store()
    this.state = {
      uploadElementKey: '' // 上传按钮重新渲染
    }
  }

  componentDidMount() {
    const { getAlbumInfo, ALBUM, getPrivilege, getPanoList } = this.store
    // 照片
    getAlbumInfo(ALBUM.PHOTO)
    // 视频
    getAlbumInfo(ALBUM.VIDEO)
    // 获取vr权限
    getPrivilege()
    // 获取酒店全景列表
    getPanoList()
  }

  // 上传图片成功
  uploadedImage = info => {
    const { scene, changeCover } = this.props
    const { triggerUploading } = this.store
    const { width, height, url } = info
    const cover = {
      width,
      height,
      cover_path: url
    }
    setTimeout(() => triggerUploading(), 300) // 关闭loading
    changeCover(scene, cover)
  }

  // 移除照片
  removePhoto = () => {
    const { scene, changeCover } = this.props
    changeCover(scene, '')
    this.setState({
      uploadElementKey: Math.random()
    })
  }

  // 上传视频成功
  uploadedVideo = video => {
    const { scene, changeCover } = this.props
    const { uploadedVideo } = this.store
    const cover = uploadedVideo(video)

    changeCover(scene, cover)
  }

  // 从相册添加
  addFromAlbum = (video, photos) => {
    const { MODAL, triggerModal } = this.store
    const { scene, changeCover } = this.props
    triggerModal(MODAL.ALBUM)

    if (scene === 'video') {
      // 设置该视频是已通过审核的
      const cover = {
        ...video,
        status: 1
      }
      delete cover.id
      changeCover(scene, cover)
      return
    }
    const cover = photos.map(p => {
      const { width, height, url } = p
      const _cover = {
        width,
        height,
        cover_path: url,
        status: 1
      }
      return _cover
    })
    changeCover(scene, cover[0])
    setTimeout(() => {
      const actionBtn = document.getElementsByClassName(
        'hljd-upload-list-item-card-actions-btn'
      )
      actionBtn[0].click()
    }, 300)
    // actionBtn[1].click()
  }

  renderVrTempContent = () => {
    const { panoList, selectVrCover } = this.store
    const { changeCover, coverInfo } = this.props
    const defaultCover =
      'https://qnm.hunliji.com/o_1d4k5mimi1bll6ru61gppe17sb9.png'

    if (this.store.vrPrivilege) {
      return (
        <div>
          <Link to={VR_CREATE_PATH}>
            <Button type="default">制作全景图</Button>
          </Link>
          <div className={style['pano-box']}>
            {panoList &&
              panoList.map((pano, i) => (
                <div
                  onClick={() =>
                    selectVrCover(i, changeCover, coverInfo.pano_id)
                  }
                  key={pano.id}
                  className={style.pano}
                  style={{
                    cursor:
                      pano.status === VR_VERIFY_SUC ? 'pointer' : 'not-allowed'
                  }}
                >
                  <img
                    src={corpImage(pano.cover || defaultCover, '16:9')}
                    className={style.img}
                  />
                  {pano.status === VR_VERIFY_SUC && (
                    <span className={style.checkbox}>
                      <Checkbox
                        checked={coverInfo.pano_id == pano.id}
                        onChange={() =>
                          selectVrCover(i, changeCover, coverInfo.pano_id)
                        }
                      />
                    </span>
                  )}
                  {/*<span className={style.status}>
                    {statusList[pano.status]}
                      </span>*/}
                  <div className={style.time}>
                    {pano.created_at.replace(/(\d+:){2}\d+/, '')}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )
    }
    return (
      <Link to={VR_SELL_PATH}>
        <Button type="primary">立即开通</Button>
      </Link>
    )
  }

  render() {
    const { scene, coverInfo } = this.props
    const {
      visible,
      photoAlbum,
      videoAlbum,
      isUploading,
      uploadVideoError,
      uploadedImageError,
      triggerUploading,
      triggerModal,
      MODAL,
      ALBUM
    } = this.store
    const { uploadedVideo, removePhoto, uploadedImage } = this

    const UploadButton = () => {
      switch (scene) {
        case 'video':
          if (coverInfo.origin && coverInfo.cover_path) {
            return (
              <ImgCard
                isVideo={true}
                src={coverInfo.cover_path}
                onDelete={removePhoto}
              />
            )
          }
          return (
            <div
              className={style.placeholder}
              style={{ width: '178px' }}
              onClick={() => triggerModal(MODAL.UPLOAD)}
            >
              <PlusOutlined style={{ color: '#aaa', marginBottom: '10px' }} />
              <p>上传视频</p>
            </div>
          )
        default:
          return (
            <ImgUpload
              coverInfo={coverInfo}
              uploadedError={uploadedImageError}
              uploadedSuccess={uploadedImage}
              beforeUpload={triggerUploading}
              removePhoto={removePhoto}
              isUploading={isUploading}
            />
          )
      }
    }

    return (
      <div>
        <div className={style.content}>
          <div className={style.cards}>
            <div className={style.btns}>
              <UploadButton key={this.state.uploadElementKey} />
              <Button
                style={{ marginLeft: '10px' }}
                type="default"
                onClick={() => triggerModal(MODAL.ALBUM)}
              >
                从相册添加
              </Button>
            </div>
          </div>
        </div>

        <AlbumModal
          type={scene === 'video' ? ALBUM.VIDEO : ALBUM.PHOTO}
          scene={scene}
          medias={scene === 'video' ? videoAlbum : photoAlbum}
          onModalOk={this.addFromAlbum}
          onCancel={() => triggerModal(MODAL.ALBUM)}
          visible={visible.albumModal}
        />

        <VideoUpload
          modal_visible={visible.uploadModal}
          onVideoOk={uploadedVideo} // 模态框点击确定后的回调
          onVideoCancel={() => triggerModal(MODAL.UPLOAD)} // 模态框点击取消后的回调
          onVideoError={uploadVideoError}
        />
      </div>
    )
  }
}
